define.alias("shared/components/shared/tax-id-form", "settings/components/shared/tax-id-form");